import { z } from "zod";
import { ServicedProductFieldsSchema } from "./ServicedProduct";
import { BaseChangelogSchema } from "./Changelog";

export const ServicedProductChangelogSchema = BaseChangelogSchema.extend({
  accountUser: z.any(),
  servicedProduct: ServicedProductFieldsSchema,
});
export const PartialServicedProductChangelogSchema =
  ServicedProductChangelogSchema.deepPartial();

export type PartialServicedProductChangelog = z.infer<
  typeof PartialServicedProductChangelogSchema
>;

export type ServicedProductChangelog = z.infer<
  typeof ServicedProductChangelogSchema
>;
